import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatPercentage } from 'I18n/utils/internal/light/numberFormatters';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "LineItemCheckoutFee__StyledDiv"
})(["white-space:-o-pre-wrap;"]);
const LineItemCheckoutFee = ({
  checkoutFeeAdjustment
}) => {
  return /*#__PURE__*/_jsx(StyledDiv, {
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      as: "small",
      "data-test-id": "line-item-tax",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.defaultCheckoutFees.plusFormattedCheckoutFee",
        options: {
          feePercentage: formatPercentage(checkoutFeeAdjustment.value, {
            precision: 2
          }),
          feeLabel: checkoutFeeAdjustment.label
        }
      })
    })
  });
};
export default LineItemCheckoutFee;